import React, { SFC } from "react";
import List from "../components/List";

const ListScreen: SFC = () => {
  return <List title="Today" />;
};

export default ListScreen;
